import React from "react";

function CrossSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="none"
      viewBox="0 0 13 13"
    >
      <path
        fill="#C81E1E"
        fillRule="evenodd"
        d="M.293.793a1 1 0 011.414 0L6 5.086 10.293.793a1 1 0 111.414 1.414L7.414 6.5l4.293 4.293a1 1 0 01-1.414 1.414L6 7.914l-4.293 4.293a1 1 0 01-1.414-1.414L4.586 6.5.293 2.207a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default CrossSvg;